import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import ICatServicios from '../../../Interfaces/Catalogos/ICatServicios'
const CatServicios: ICatServicios[] = []
const initialState = { CatServicios }

export const CatServiciosSlice = createSlice({
  name: 'CatServicios',
  initialState: initialState,
  reducers: {
    resetCatServicios : (state, action: PayloadAction<string>) => {
      state.CatServicios =  []
    },  
    populateCatServicios : (state, action: PayloadAction<ICatServicios[]>) => {
        action.payload.forEach(element => {
            const index = state.CatServicios.findIndex(object => object.id === element.id)
            if (index<0) state.CatServicios.push(element)
        })
    },
    updateCatServicios : (state, action: PayloadAction<ICatServicios>) => {
      const i = state.CatServicios.findIndex(_element => _element.id === action.payload.id);
      if (i > -1) state.CatServicios[i] = action.payload;
      else state.CatServicios.push(action.payload);
    },
    deleteCatServicios : (state, action: PayloadAction<number>) => {
      const newArr = state.CatServicios.filter(data => data.id != action.payload);
      state.CatServicios=newArr
    },
  },
})

export const { resetCatServicios, populateCatServicios, updateCatServicios, deleteCatServicios } = CatServiciosSlice.actions;
export default CatServiciosSlice.reducer;